import { FC, useCallback } from "react";
import { observer } from "mobx-react-lite";
import { StepProps } from "@/components/onboarding/components/welcome-wizard/welcome-wizard.types";
import { OnboardingMeetingsPermissionsIntro } from "@/components/onboarding/components/welcome-wizard/steps/system-permissions-meetings/components";

export const SystemPermissionsMeetingIntroStep: FC<StepProps> = observer(({ onNavToStep }) => {
  const handleNext = useCallback(() => {
    onNavToStep?.("system-permissions-meeting-permissions");
  }, [onNavToStep]);

  return <OnboardingMeetingsPermissionsIntro onNext={handleNext} />;
});
